import React from 'react';

import useRedux from 'hooks/useRedux';

import * as actionsGroupList from '../home.duck';

import Heading from './Heading';
import Footer from './Footer';
import ContentSection from './ContentSection';
import { Button } from '@material-ui/core';

import { hashHistory } from 'browserHistory';

const SignOut = () => {

    const [state, actions] = useRedux(actionsGroupList);

    const { userManager } = state;

    React.useEffect(() => {
        actions.signOut();
    }, []);

    return <div>
        <Heading showButtons={false} />
        <ContentSection maxWidth={800}>
            {!userManager.user && <div>
                You have successfully signed out
            </div>}
            <div>
                <Button variant={'outlined'} color={'primary'} onClick={() => {
                    hashHistory.push('/');
                }}>Return To Homepage</Button>
            </div>
        </ContentSection>
        <Footer  {...this.props} />
    </div>
}

export default SignOut;


// WEBPACK FOOTER //
// ./src/home/components/SignOutPage.js